import {
  ref,
  type Ref,
} from 'vue';

/** Função que verifica se o usuário tem alguma das roles informadas */
export type PermissionChecker = (_roles: string[]) => boolean;

const defaultCheck: PermissionChecker = () => false;

/**
 * Ref global com a função de checagem de permissão.
 * - App.vue chama setPermissionCheck(auth.hasSomeRole) quando o auth carrega.
 * - A diretiva v-permission lê daqui (não consegue usar useAuth/usePermission no contexto da diretiva).
 * - Em componentes, use o composable usePermission(); não leia este store diretamente.
 */
const permissionCheckRef: Ref<PermissionChecker> = ref(defaultCheck);

export function getPermissionCheck(): PermissionChecker {
  return permissionCheckRef.value ?? defaultCheck;
}

export function setPermissionCheck(fn: PermissionChecker | undefined): void {
  permissionCheckRef.value = fn ?? defaultCheck;
}

export { permissionCheckRef };
